import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export function useAccountProfileQuery(params: { impersonationContext?: Api.IImpersonationContext }) {
	const userSession = useUserSession();
	return useQuery<Api.AccountProfile | null>({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.AccountProfile>({
				path: Api.ImpersonationBroker.composeApiUrl({
					urlPath: `accountProfile`,
					impersonationContext: params.impersonationContext,
				}),
				method: 'GET',
				throwOn404: false,
			}),
		queryKey: [`accountProfile`, params.impersonationContext],
		staleTime: 5 * 60 * 1000,
	});
}

// Invalidate on the base key: callers pass impersonationContext as null, undefined or an instance, and each is a distinct cache key.
export function invalidateAccountProfileQueries() {
	return reactQueryClient.invalidateQueries({ queryKey: [`accountProfile`] });
}
